import InfoIcon from "@mui/icons-material/Info";
import { Box, Typography, IconButton } from "@mui/material";
import React from "react";

import { useCelleraTheme } from "../../../theme/useCelleraTheme";

interface IntakeHeaderProps {
  title: string;
}

const IntakeHeader: React.FC<IntakeHeaderProps> = ({ title }) => {
  const { colors } = useCelleraTheme();

  return (
    <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: colors.text.primary,
          mr: 1,
        }}
      >
        {title}
      </Typography>
      <IconButton
        size="small"
        sx={{
          backgroundColor: colors.background.default,
          color: colors.text.secondary,
          "&:hover": {
            backgroundColor: colors.background.default,
          },
        }}
      >
        <InfoIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default IntakeHeader;
